import type { AgentRunModel } from "@/api/api"

export function buildAgentRunChatPath(
  getRouteChatPath: (sessionType: string) => string,
  run: AgentRunModel
): string {
  return `${getRouteChatPath(run.session_type)}/${run.session_id}`
}
